import React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { useHeaderConfig } from "../../NavProvider";
import SsoButton from "../SsoButton";
import Divisions from "./Divisions";
import Search from "./Search";
import Container from "../Container";
var useStyles = makeStyles(createStyles({
    background: {
        backgroundColor: "#010414",
    },
    main: {
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        height: "40px",
        alignItems: "center",
        WebkitTapHighlightColor: "transparent",
    },
    action: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: "24px",
        height: "100%",
    },
}));
var MainNav = function () {
    var styles = useStyles();
    var header = useHeaderConfig();
    return (React.createElement("div", { id: "acm-header__main-nav", className: styles.background },
        React.createElement(Container, null,
            React.createElement("div", { className: styles.main },
                React.createElement(Divisions, { divisions: header.divisions, ourBrands: header.ourBrands }),
                React.createElement("div", { className: styles.action },
                    React.createElement(Search, { config: header.search }),
                    React.createElement(SsoButton, null))))));
};
export default MainNav;
